import { Reaction } from 'mobx';
import { getChangedProps, throwError, isObject, noop } from 'cerebral/internal';
function autorun(view) {
    var reaction = new Reaction(view.name || 'Autorun', function () {
        this.track(view);
    });
    reaction.runReaction();
    return reaction.getDisposer();
}
var View = /** @class */ (function () {
    function View(_a) {
        var dependencies = _a.dependencies, props = _a.props, controller = _a.controller, displayName = _a.displayName, onUpdate = _a.onUpdate;
        if (!dependencies) {
            throwError('There is no reason to connect a component that has no dependencies');
        }
        if (typeof dependencies !== 'function') {
            throwError('You have to define a function for the dependencies');
        }
        this.props = props;
        this.controller = controller;
        this._displayName = displayName;
        this._hasWarnedBigComponent = false;
        this.isUnmounted = false;
        this.updateComponent = onUpdate || noop;
        this.propKeys = Object.keys(props || {});
        this._verifyPropsWarned = false;
        this.dependencies = dependencies;
        this.autorun = null;
        this.cerebralProps = {};
        this.isMounted = false;
    }
    View.prototype.registerAutorun = function () {
        var _this = this;
        this.autorun = autorun(function () {
            _this.cerebralProps = _this.dependencies({
                state: _this.controller.state,
                signals: _this.controller.signals,
                props: _this.props,
            });
            if (_this.isMounted) {
                _this.onUpdate();
            }
        });
    };
    View.prototype.mount = function () {
        this.registerAutorun();
        this.isMounted = true;
        if (!isObject(this.cerebralProps)) {
            throwError('You have to return dependencies from the dependency function');
        }
        if (this.controller.devtools) {
            // this.controller.devtools.updateComponentsMap(this, depsMap)
        }
    };
    View.prototype.onUpdate = function () {
        if (this.isUnmounted) {
            return;
        }
        this.updateComponent();
    };
    View.prototype.unMount = function () {
        if (this.autorun) {
            this.autorun();
        }
        if (this.controller.devtools) {
            // this.controller.devtools.updateComponentsMap(this, null, depsMap)
        }
        this.isUnmounted = true;
    };
    View.prototype.onPropsUpdate = function (props, nextProps) {
        var propsChanges = getChangedProps(props, nextProps);
        if (propsChanges.length) {
            this.props = nextProps;
            this.autorun();
            this.registerAutorun();
            return true;
        }
        return false;
    };
    View.prototype.getProps = function (props, includeProps) {
        if (props === void 0) { props = {}; }
        if (includeProps === void 0) { includeProps = true; }
        var dependenciesProps = this.cerebralProps;
        if (this.controller.devtools &&
            this.controller.devtools.bigComponentsWarning &&
            !this._hasWarnedBigComponent &&
            Object.keys(dependenciesProps).length >=
                this.controller.devtools.bigComponentsWarning) {
            console.warn("Component named " + this._displayName + " has a lot of dependencies, consider refactoring or adjust this option in devtools");
            this._hasWarnedBigComponent = true;
        }
        return Object.assign({}, includeProps ? props : {}, dependenciesProps);
    };
    return View;
}());
export default View;
//# sourceMappingURL=View.js.map


//////////////////
// WEBPACK FOOTER
// /home/kryd0s/tmp/widgetbot/node_modules/@cerebral/fluent/es/View.js
// module id = 152
// module chunks = 0